export default "__VITE_ASSET__CUrkIzv$__"